import{__awaiter as o}from"tslib";import{fetchGet as t}from"./lib/fetch.js";const i=o=>o.then((()=>{})),r=(i,r,e)=>o(void 0,void 0,void 0,(function*(){return yield i.then((()=>e?e(r):t(r)))}));export{r as castPromiseToItself,i as castPromiseToUndefined};
//# sourceMappingURL=cast.js.map
